import { Anchor, AnchorProps } from "~/components/Anchor";
import { useOrgRouter } from "~/utils/paths";

export const OrgAnchor = ({ href, children, ...rest }: AnchorProps) => {
  const router = useOrgRouter();
  return (
    <Anchor {...rest} href={router.makeOrgPath(href)}>
      {children}
    </Anchor>
  );
};

export type OrgAnchorProps = AnchorProps;
